import React, {useCallback, useRef, useState} from 'react';

// components
import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';

// design-components
import MainTable from '../../designComponents/tables/MainTable';
import MainPageTitle from '../../designComponents/titles/MainPageTitle';
import FlexMainWrapper, {Wrapper02} from '../../designComponents/wrappers/FlexMainWrapper';

// utils
import {availFilter, dateFilter} from '../../utils/textFilter';
import SearchbarWithDropdown from '../../designComponents/searchbars/SearchbarWithDropdown';

// reactBootstrap
import TableFilter from '../../designComponents/filters/TableFilter';
import {makeImageUrl} from "../../designComponents/imageboxs/Image";

/** 채팅페이지 */
const RandomChatting = () => {
    const [param, setParam] = useState({
        order: null,
    });
    const [searchType, setSearchType] = useState('user_id');
    const [searchText, setSearchText] = useState('');

    const ref = useRef();
    const tableRef = useRef();

    const callApi02 = async (page, param) => {
        try {
            const input = {
                searchType: searchType,
                searchWord: searchText,
                page: page,
                size: 10,
                ...param,
            };
            const response = await RefreshCheckApi.post(`/adminChatting/random/list`, input);
            return response.data.data;
        } catch (error) {
            console.error('error: ', error);
        }
    };

    const pageCountCallApi02 = async (page, param) => {
        try {
            const input = {
                searchType: searchType,
                searchWord: searchText,
                page: page,
                size: 10,
                order: 0,
                ...param,
            };
            const response = await RefreshCheckApi.post(`/adminChatting/random/list`, input);
            return response.data.allCount;
        } catch (error) {
            console.error('error: ', error);
        }
    };

    return (
        <Wrapper02>
            <MainPageTitle text={'88다방 리스트'} onClick={() => ref?.current?.refresh()}/>
            <SearchbarWithDropdown
                list={[
                    {id: 1, title: '회원 ID', value: 'user_id'},
                    {id: 2, title: '닉네임', value: 'nick_name'},
                ]}
                resetThenSet={useCallback((item) => {
                    setSearchType(item.value);
                }, [])}
                onChangeSubmit={(e) => {
                    e.preventDefault();
                    ref?.current?.refresh();
                }}
                searchText={searchText}
                onChangeInput={(e) => {
                    setSearchText(e.target.value);
                }}
                setSearchText={setSearchText}
            />
            <TableFilter
                param={param}
                setParam={setParam}
                topFilterLists={[
                    {
                        filterText: '상태',
                        orderLists: [
                            { name: '매칭', width: 70, type: 1 },
                            { name: '신청', width: 70, type: 0 },
                        ],
                        onChange: (e, type) => {
                            let obj = { ...param };
                            if (e.target.checked) obj.type = type;
                            else delete obj.type;
                            setParam(obj);
                        },
                        orderbyType: param.type,
                    },
                ]}
                research={ref}
            />
            <FlexMainWrapper>
                <MainTable
                    buttonComponents={({checkItems}) => {
                    }}
                    ref={ref}
                    checkAble={false}
                    tableStyle={{width: '98%'}}
                    tableRef={tableRef}
                    loadingText={'매칭 내역을 불러오고 있습니다.'}
                    headerData={[
                        {
                            key: 'user_id',
                            value: '회원 ID',
                        },
                        {
                            key: 'couple_id',
                            value: '매칭 상대 ID',
                        },
                        {
                            key: 'status',
                            value: '상태',
                        },
                        {
                            key: 'nick_name',
                            value: '닉네임',
                        },
                        {
                            key: 'sex',
                            value: '성별',
                        },
                        {
                            key: 'age',
                            value: '나이',
                        },
                        {
                            key: 'profile',
                            value: '프로필',
                        },
                        {
                            key: 'expression',
                            value: '자기 소개',
                        },
                        {
                            key: 'address',
                            value: '주소',
                        },
                        {
                            key: 'report',
                            value: '신고한 회원 ID',
                        },
                        {
                            key: 'created_at',
                            value: '생성일',
                        },
                    ]}
                    param={param}
                    setParam={setParam}
                    toggleBlur={true}
                    callApi={callApi02}
                    pageCountCallApi={pageCountCallApi02}
                    tbodyRenderItem={(key, value, data) => {
                        if (key === 'status') {
                            return availFilter(value, '매칭', '신청');
                        }
                        if (key === 'sex') return value === 1 ? '남자' : value === 2 ? '여자' : '-';
                        if (key === 'created_at' || key === 'updated_at') return dateFilter(value);
                        if (key === 'profile') return value ? <img src={makeImageUrl(value)} alt="profile" style={{width: 50, height: 50}}/> : '프로필 없음';
                        if (key === 'report') {
                            if (!value) return '신고 없음';

                            const splitValue = value.split(',');
                            return (
                                <div>
                                    {splitValue.map((item, index) => {
                                        if (index % 5 === 0 && index !== 0) {
                                            return <br key={index}/>;
                                        }

                                        if (index === splitValue.length - 1) {
                                            return <span key={index}>{item}</span>;
                                        }

                                        return <span key={index}>{item}, </span>;
                                    })}
                                </div>
                            );
                        }
                        if (key === 'expression') {
                            if (!value) return '자기소개 없음';

                            const splitValue = value.split(',');
                            return (
                                <div>
                                    {splitValue.map((item, index) => {
                                        if (index % 2 === 0 && index !== 0) {
                                            return <br key={index}/>;
                                        }

                                        if (index === splitValue.length - 1) {
                                            return <span key={index}>{item}</span>;
                                        }

                                        return <span key={index}>{item}, </span>;
                                    })}
                                </div>
                            );
                        }
                        return value;
                    }}
                />
            </FlexMainWrapper>
        </Wrapper02>
    );
};

export default RandomChatting;
